<template>
  <tr class="delivery-end-row-component" :class="{'odd-row': index % 2 === 1, 'hover-row': hoverRow}" @mouseenter="hoverRow = true" @mouseleave="hoverRow = false">
    <td rowspan="2" colspan="10">{{ `Tur ${trip_name} slut` }}</td>
    <td class="is-lockable" colspan="4">Kør hjem</td>
    <td class="is-lockable pull-down cell-highlight">
      <time-picker v-model="driveStart" :tabindex="100 * (tripIndex + 1) - 9" :disabled="!last_order.deliveryStart" />
    </td>
    <td class="is-lockable pull-down cell-highlight">
      <duration-picker v-model="driveDuration" :tabindex="100 * (tripIndex + 1) - 8" />
    </td>
    <td class="is-lockable pull-down cell-highlight">
      <time-picker v-model="driveEnd" :tabindex="100 * (tripIndex + 1) - 7" :disabled="!last_order.deliveryStart" />
    </td>
    <td class="is-lockable" colspan="3"></td>
  </tr>
  <tr class="delivery-end-row-component" :class="{'odd-row': index % 2 === 1, 'hover-row': hoverRow}" @mouseenter="hoverRow = true" @mouseleave="hoverRow = false">
    <td class="is-lockable" colspan="4">Tøm bil</td>
    <td class="is-lockable pull-up">
      <time-picker v-model="deliveryStart" :tabindex="100 * (tripIndex + 1) - 6" :disabled="!driveEnd" />
    </td>
    <td class="is-lockable pull-up">
      <duration-picker v-model="deliveryDuration" :tabindex="100 * (tripIndex + 1) - 5" />
    </td>
    <td class="is-lockable pull-up">
      <time-picker v-model="deliveryEnd" :tabindex="100 * (tripIndex + 1) - 4" :disabled="!deliveryStart" />
    </td>
    <td class="is-lockable" colspan="3"></td>
  </tr>
</template>
  
<script>
import { ref, computed } from 'vue'
import moment from 'moment/moment';
import TimePicker from './TimePicker.vue';
import DurationPicker from './DurationPicker.vue';
import { useRouteDataStore } from '../stores/route-data';

export default {
  components: { DurationPicker, TimePicker },
  props: {
    trip_name: {
      type: String,
      required: true,
    },
    last_order: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const routeDataStore = useRouteDataStore();
    const hoverRow = ref(false);

    const id = computed(() => {
      return `${props.trip_name}_end`;
    });

    const driveStart = computed({
      get() {
        if (props.last_order && props.last_order.deliveryEnd) {
          return props.last_order.deliveryEnd;
        } else {
          return null;
        }
      },
      set(newValue) {
        // console.log('end row - driveStart set', newValue);
        if (driveEnd.value && newValue && driveDuration.value === null) {
          driveDuration.value = moment(driveEnd.value, 'HH:mm').diff(moment(newValue, 'HH:mm'), 'minutes');
        }
        props.last_order.deliveryEnd = newValue;
      }
    });

    const driveDuration = computed({
      get() {
        if (Object.hasOwn(routeDataStore.routeData.drive_durations, id.value)) {
          return routeDataStore.routeData.drive_durations[id.value];
        } else {
          return null;
        }
      },
      set(newValue) {
        // console.log('end row - driveDuration set', newValue);
        const currentValue = driveDuration.value;
        if (currentValue !== null && newValue !== null) {
          const diff = newValue - driveDuration.value;
          const newStartValue = moment(driveStart.value, 'HH:mm').subtract(diff, 'minutes').format('HH:mm');
          props.last_order.deliveryEnd = newStartValue;
        }
        routeDataStore.routeData.drive_durations[id.value] = newValue;
      }
    });

    const driveEnd = computed({
      get() {
        if (driveStart.value && driveDuration.value !== null) {
          return moment(driveStart.value, 'HH:mm').add(driveDuration.value, 'minutes').format('HH:mm');
        } else {
          return null;
        }
      },
      set(newValue) {
        // console.log('end row - driveEnd set', newValue);
        if (driveStart.value && newValue && driveDuration.value === null) {
          driveDuration.value = moment(newValue, 'HH:mm').diff(moment(driveStart.value, 'HH:mm'), 'minutes');
        }
        if (driveEnd.value && newValue) {
          const diff = moment(newValue, 'HH:mm').diff(moment(driveEnd.value, 'HH:mm'), 'minutes');
          const newStartValue = moment(driveStart.value, 'HH:mm').add(diff, 'minutes').format('HH:mm');
          props.last_order.deliveryEnd = newStartValue;
        }
      }
    });

    const deliveryStart = computed({
      get() {
        return driveEnd.value;
      },
      set(newValue) {
        // console.log('end row - deliveryStart set', newValue);
        if (deliveryStart.value && newValue) {
          const diff = moment(newValue, 'HH:mm').diff(moment(deliveryStart.value, 'HH:mm'), 'minutes');
          const newStartValue = moment(driveStart.value, 'HH:mm').add(diff, 'minutes').format('HH:mm');
          props.last_order.deliveryEnd = newStartValue;
        }
      }
    });

    const deliveryDuration = computed({
      get() {
        if (Object.hasOwn(routeDataStore.routeData.service_durations, id.value)) {
          return routeDataStore.routeData.service_durations[id.value];
        } else {
          return 10;
        }
      },
      set(newValue) {
        // console.log('end row - deliveryDuration set', newValue);
        const diff = newValue - deliveryDuration.value;
        const newStartValue = moment(driveStart.value, 'HH:mm').subtract(diff, 'minutes').format('HH:mm');
        routeDataStore.routeData.service_durations[id.value] = newValue;
        props.last_order.deliveryEnd = newStartValue;
      }
    });

    const deliveryEnd = computed({
      get() {
        if (deliveryStart.value && deliveryDuration.value) {
          return moment(deliveryStart.value, 'HH:mm').add(deliveryDuration.value, 'minutes').format('HH:mm');
        } else {
          return null;
        }
      },
      set(newValue) {
        // console.log('end row - deliveryEnd set', newValue);
        const diff = moment(newValue, 'HH:mm').diff(moment(deliveryEnd.value, 'HH:mm'), 'minutes');
        const newStartValue = moment(driveStart.value, 'HH:mm').add(diff, 'minutes').format('HH:mm');
        props.last_order.deliveryEnd = newStartValue;
      }
    });
    
    const tripNames = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
    const tripIndex = computed(() => {
      return tripNames.indexOf(props.trip_name);
    });

    return {
      hoverRow,
      driveStart,
      driveDuration,
      driveEnd,
      deliveryStart,
      deliveryDuration,
      deliveryEnd,
      tripIndex,
    };
  }
}
</script>

<style lang="scss" scoped>
.delivery-end-row-component {
  transition: background-color 0.25s ease, border-color 0.25s ease;
  &.odd-row {
    background-color: #f0f0f0;
  }
  &.hover-row {
    background-color: #b8daff;
    border-color: #7abaff;
  }
  
  td {
    vertical-align: middle;
  }
}
</style>